<template>

    <!-- BEGIN Base Outer Element -->
    <div id="main-player-view" class="h-full rounded-t-lg flex flex-row bg-theme-level4 items-stretch">

        <!-- BEGIN Left Column -->
        <div id="left-column" class="relative bg-theme-level4 w-3/5 rounded-tl-lg flex flex-col" style="min-width: 468px;">

            <!-- BEGIN The player itself, Title, Separator -->
            <div id="player-container" class="pl-6 pt-6 pr-6">

                <video-player :currentlocale="currentlocale"></video-player>

            </div>



            <!-- END The player itself, Title, Separator -->

            <vue-scroll :ops="this.$root.shared.scrollops">

                <div class="overflow-y-auto">

                    <div v-text="this.$root.shared.playerPayload.title"
                         class="text-2xl text-theme-main font-bold ml-6 mr-6 pt-2 pb-4 leading-tight border-b border-theme-level1"></div>

                    <!-- BEGIN Viz, Thumbs and some controls -->
                    <div class="border-b border-theme-level1 mr-6 ml-6 pr-2 py-2 text-theme-discrete flex flex-row justify-between items-center">

                        <div class="flex flex-row items-center justify-between">

                            <span class="text-sm"><span v-text="this.$root.shared.contentPlays"></span> {{ translate('playerview-views')}}</span>

                            <div class="ml-8 flex flex-row items-center">
                                <i v-if="isLikeable" class="material-icons mr-2 pl-1 cursor-pointer w-6 h-6 text-theme-discrete hover:text-theme-main" @click="updateLikes">thumb_up</i>
                                <i v-else class="material-icons mr-2 pl-1 w-6 h-6 text-theme-discrete">thumb_up</i>
                                <p class="mr-2 text-sm text-green-600" v-text="this.$root.shared.contentLikes"></p>
                                <i v-if="isDislikeable" class="material-icons ml-2 mr-2 pl-1 cursor-pointer w-6 h-6 text-theme-discrete hover:text-theme-main" @click="updateDislikes">thumb_down</i>
                                <i v-else class="material-icons ml-2 mr-2 pl-1 w-6 h-6 text-theme-discrete">thumb_down</i>
                                <p class="text-sm text-red-700" v-text="this.$root.shared.contentDislikes"></p>
                            </div>

                            <p v-if="userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))"
                               @click.stop="editContent"
                               class="ml-16 text-red-300 hover:text-red-500 hover:underline cursor-pointer">{{ translate('content-edit-in-module') }}</p>

<!--                            <p v-if="userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))"
                               @click.stop="moderateComments"
                               class="ml-16 text-red-300 hover:text-red-500 hover:underline cursor-pointer">{{ translate('content-moderate-in-module') }}</p>-->

                        </div>

                        <div class="">
                            <i class="material-icons mr-2 pt-1 cursor-pointer w-6 h-6 text-theme-discrete hover:text-theme-main invisible">playlist_add</i>
                            <i class="material-icons mr-2 pt-1 cursor-pointer w-6 h-6 text-theme-discrete hover:text-theme-main invisible">av_timer</i>
                        </div>

                    </div>
                    <!-- END Viz, Thumbs and some controls -->

                        <!--<div id="comments-container" class="p-6 pb-24 text-theme-muted text-sm leading-normal mt-4 ml-6 mr-6" :class="{'bg-theme-level3': this.$root.shared.theme==='theme-dark'}">
                            <div class="fb-comments" :data-href="commentsUrl" data-numposts="5" data-width="" :data-colorscheme="commentsTheme" style="color: white !important;"></div>
                        </div>-->

                        <div id="comments-container" class="pb-24 text-theme-muted text-sm leading-normal mt-4">
                            <comments-component :language="currentlocale" :content_id="this.$root.shared.playerPayload.id"></comments-component>
                        </div>

                </div>

            </vue-scroll>

        </div>
        <!-- END Left Column -->

        <!-- BEGIN Right Column -->
        <div id="right-column" class="relative bg-theme-level3 w-2/5 rounded-tr-lg overflow-y-auto" style="min-width: 312px;">

            <vue-scroll :ops="this.$root.shared.scrollops">

                <div id="info-container" class="relative pt-6 pr-8 flex-1 bg-theme-level4 rounded-tr-lg flex flex-col">

                    <div id="content-abstract" class="text-sm text-theme-discrete leading-normal" v-text="this.$root.shared.playerPayload.abstract">
                    </div>

                    <div id="content-date" class="flex flex-row items-center text-sm text-theme-discrete mt-4">
                        <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                        <span class="flex-1">
                            <span>{{  translate('published-on') }}</span> <span v-text="this.$root.shared.playerPayload.publish_date.split(' ')[0]"></span>,
                            <span>{{  translate('at') }}</span> <span v-text="this.$root.shared.playerPayload.publish_date.split(' ')[1]"></span></span>
                    </div>

                    <div id="content-correspondent" class="mt-4">
                        <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-correspondent') }}</p>
                        <div v-if="this.$root.shared.playerCategories[5] !== ''" class="flex flex-row flex-wrap">
                                <span
                                      class="bg-theme-controls3 hover:bg-theme-controls2 cursor-pointer text-theme-control-label text-xs rounded-full px-3 py-1 mr-1 mt-1"
                                      v-text="this.$root.shared.playerCategories[5]" @click.stop="gotoCorrespondent">
                                </span>
                        </div>
                        <div v-else class="flex flex-row flex-wrap">
                            <p class="text-theme-muted text-xs">{{ translate('playerview-no-correspondent') }}</p>
                        </div>
                    </div>

                    <div id="content-pois" class="mt-4">
                        <p class="text-theme-discrete text-xs">{{ translate('playerview-pois') }}</p>
                        <div v-if="this.$root.shared.playerCategories[2].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="person in this.$root.shared.playerCategories[2]" v-if="person !== $root.shared.playerCategories[5]"
                                    class="hover:underline hover:text-theme-title cursor-pointer text-theme-main text-sm rounded py-1 mr-3 mt-1"
                                    v-text="person" @click.stop="gotoPoi(person)">
                                </span>
                        </div>
                        <div v-else class="flex flex-row flex-wrap">
                            <p class="text-theme-muted text-xs">{{ translate('playerview-no-poi') }}</p>
                        </div>
                    </div>

                    <div id="content-categories" class="mt-4">
                        <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-categories') }}</p>
                        <div class="flex flex-row flex-wrap">
                                <span v-for="this_category in this.$root.shared.playerCategories[0]"
                                   class="bg-theme-controls3 hover:bg-theme-controls2 cursor-pointer text-theme-control-label text-xs rounded-full px-3 py-1 mr-1 mt-1"
                                   v-text="this_category" @click.stop="gotoCategory(this_category)">
                                </span>
                        </div>
                    </div>

                    <div id="content-subcategories" class="mt-4">
                        <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-subcategories') }}</p>
                        <div v-if="this.$root.shared.playerCategories[3].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="this_subcategory in this.$root.shared.playerCategories[3]"
                                      class="bg-theme-controls3 hover:bg-theme-controls2 cursor-pointer text-theme-control-label text-xs rounded-full px-3 py-1 mr-1 mt-1"
                                      v-text="this_subcategory" @click.stop="gotoSubCategory(this_subcategory)">
                                </span>
                        </div>
                        <div v-else class="flex flex-row flex-wrap">
                            <p class="text-theme-muted text-xs">{{ translate('playerview-no-subcat') }}</p>
                        </div>
                    </div>

                    <div id="content-countries" class="mt-4">
                        <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-countries') }}</p>
                        <div v-if="this.$root.shared.playerCategories[4].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="country in this.$root.shared.playerCategories[4]"
                                      class="bg-theme-copy4 hover:bg-theme-copy3 cursor-pointer text-theme-control-label text-xs rounded px-3 py-1 mr-1 mt-1"
                                      v-text="country" @click.stop="gotoCountry(country)">
                                </span>
                        </div>
                        <div v-else class="flex flex-row flex-wrap">
                            <p class="text-theme-muted text-xs">{{ translate('playerview-no-country') }}</p>
                        </div>
                    </div>

                    <div id="content-tags" class="mt-4">
                        <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-tags') }}</p>
                        <div v-if="this.$root.shared.playerCategories[1].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="tag in this.$root.shared.playerCategories[1]"
                                      class="bg-theme-copy4 hover:bg-theme-copy3 cursor-pointer text-theme-control-label text-xs rounded px-3 py-1 mr-1 mt-1"
                                      v-text="tag" @click.stop="gotoTag(tag)">
                                </span>
                        </div>
                        <div v-else class="flex flex-row flex-wrap">
                            <p class="text-theme-muted text-xs">{{ translate('playerview-no-tag') }}</p>
                        </div>
                    </div>

                    <div class="flex flex-row justify-between mt-6 mb-4">
                        <div class="mr-1">
                            <!-- FACEBOOK SHARE -->
                            <span @click.stop="">
                                <ShareNetwork
                                    network="facebook"
                                    :url="shareableLinkCode"
                                    :title="this.$root.shared.playerPayload.title"
                                    :description="this.$root.shared.playerPayload.abstract"
                                >
                                    <i class="material-icons mr-1 pl-2 pt-2 cursor-pointer w-10 h-10 icon-circled text-theme-discrete hover:text-theme-main" style="height: 34px; width: 34px; padding-left:7px; padding-top: 7px;">
                                        <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px">
                                            <path d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2 C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z"/>
                                        </svg>
                                    </i>
                                </ShareNetwork>
                            </span>

                            <!-- TWITTER SHARE -->
                            <span @click.stop="">
                                <ShareNetwork
                                    network="twitter"
                                    :url="shareableLinkCode"
                                    :title="this.$root.shared.playerPayload.title"
                                    hashtags="telesurtv"
                                    twitter-user="telesurtv"
                                >
                                    <i class="material-icons mr-1 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="height: 34px; width: 34px; padding-left:6px; padding-top: 6px;">
                                        <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px">
                                            <path d="M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z"/>
                                        </svg>
                                    </i>
                                </ShareNetwork>
                            </span>

                            <!-- WHATSAPP SHARE -->
                            <span @click.stop="">
                                <ShareNetwork
                                    network="whatsapp"
                                    :url="shareableLinkCode"
                                    :title="this.$root.shared.playerPayload.title"
                                    :description="this.$root.shared.playerPayload.abstract"
                                >
                                    <i class="material-icons mr-1 pl-2 pt-2 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="height: 34px; width: 34px; padding-left:8px; padding-top: 7px;">
                                        <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px">
                                            <path d="M19.077,4.928C17.191,3.041,14.683,2.001,12.011,2c-5.506,0-9.987,4.479-9.989,9.985 c-0.001,1.76,0.459,3.478,1.333,4.992L2,22l5.233-1.237c1.459,0.796,3.101,1.215,4.773,1.216h0.004 c5.505,0,9.986-4.48,9.989-9.985C22.001,9.325,20.963,6.816,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186 c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767c-0.125-0.167-1.019-1.353-1.019-2.581 S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006c0.178,0.007,0.375,0.016,0.562,0.431 c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416c-0.125,0.146-0.262,0.325-0.374,0.437 c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728c0.954,0.85,1.757,1.113,2.007,1.239 c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812 c0.25,0.125,0.416,0.187,0.478,0.291C17.106,14.471,17.106,14.971,16.898,15.554z"/>
                                        </svg>
                                    </i>
                                </ShareNetwork>
                            </span>

                            <!-- EMBED BUTTON -->
                            <span @click.stop="getEmbedCode">
                                <i class="material-icons mr-1 pl-2 pt-2 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="height: 34px; width: 34px; padding-left:8px; padding-top: 8px;">
                                    <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px">
                                        <path d="M0 0h24v24H0z" fill="none"/><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>
                                    </svg>
                                </i>
                            </span>

                            <!-- YOUTUBE CHANNEL -->
                            <!--<i class="material-icons mr-1 pl-2 pt-2 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="height: 34px; width: 34px; padding-left:8px; padding-top: 8px;">-->
                            <i class="material-icons mr-1 pl-2 pt-2 icon-circled text-theme-discrete opacity-25" style="height: 34px; width: 34px; padding-left:8px; padding-top: 8px;">
                                <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px">
                                    <path d="M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z"/>
                                </svg>
                            </i>

                            <!-- SHAREABLE LINK -->
                            <span @click.stop="getShareableLink">
                                <i class="material-icons mr-1 pl-2 pt-2 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="height: 34px; width: 34px; padding-left:8px; padding-top: 8px;">
                                    <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="18px">
                                        <path d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
                                    </svg>
                                </i>
                            </span>

                        </div>

                        <div v-if="downloadable" class="flex flex-row items-center">
                            <i class="material-icons mt-0 mr-2 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="width: 34px; height: 34px; padding-left:5px; padding-top: 5px;" @click.stop="downloadContent">get_app</i>
                            <!--<span class="text-theme-muted" style="font-size: 10px;"><span v-if="currentlocale==='es'">Disponible<br />para<br />Descarga</span><span v-if="currentlocale==='es'">Available<br />for<br />Download</span></span><br />-->
                        </div>
                        <div v-else class="flex flex-row items-center">
                            <i class="material-icons mt-0 mr-2 icon-circled text-theme-discrete opacity-25" style="width: 34px; height: 34px; padding-left:5px; padding-top: 5px;">get_app</i>
                            <!--<span class="text-theme-muted" style="font-size: 10px;"><span v-if="currentlocale==='es'">No Disponible<br />para<br />Descarga</span><span v-if="currentlocale==='es'">Unavailable<br />for<br />Download</span></span><br />-->
                        </div>

                    </div>

                </div>

                <div class="px-6 py-4 border-b border-theme-level1 text-theme-discrete bg-theme-level3 flex flex-row justify-between">
                    <span>{{ translate('coming-up') }}:</span>
                    <div>
                        <label for="toggle" class="text-theme-discrete mr-2">{{ translate('autoplay') }}</label>
                        <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                            <input type="checkbox" name="toggle" id="toggle" v-model="$root.shared.autoplayIsEnabled"
                                   class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer outline-none"
                                   @click="toggleAutoplay"
                            />
                            <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
                        </div>
                    </div>
                </div>


                <div class="h-full relative px-4 pt-4 flex flex-col bg-theme-level3" style="min-height: 500px;">

                    <!-- BEGIN COMING UP MODULE -->
                    <coming-up :currentlocale="currentlocale" :active_content_id="this.$root.shared.playerPayload.id" :default_thumbnail="default_thumbnail" :user="currentUser"></coming-up>
                    <!-- END COMING UP MODULE -->

                </div>

                <div class="h-24"></div>


                <flash-message :position="'right bottom'" style="z-index: 999999999; pointer-events: none;" class="p-6"></flash-message>

            </vue-scroll>

            <!-- BEGIN CLOSE BUTTON -->
            <div class="absolute rounded-tr-lg" style="top: 0; right: 0;">
                <i class="material-icons pt-2 pr-2 text-theme-discrete hover:text-theme-main cursor-pointer" @click="closePlayer">highlight_off</i>
            </div>
            <!-- END CLOSE BUTTON -->

        </div>
        <!-- END Right Column -->


        <div v-if="embedCodePanelVisible" class="absolute w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
            <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 22rem;">
                <span class="text-base text-theme-main font-bold mb-4">{{ translate('embed-code-title') }}</span>
                <span class="text-sm text-theme-discrete font-bold mb-6">{{ translate('embed-code-description') }}</span>
                <div class="text-sm text-theme-discrete mb-6">
                    <pre style="white-space: pre-wrap;"><code>{{ embedCode }}</code></pre>
                </div>
                <div class="flex flex-row items-center justify-center">
                    <button class="flex flex-row items-center justify-center text-base hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            :class="{'bg-theme-controls3': !embedCodeWasCopied && !embedCodeHadError, 'bg-green-500 hover:bg-green-500': embedCodeWasCopied, 'bg-red-500 hover:bg-red-500': embedCodeHadError}"
                            @click.stop="copyEmbedCodeToClipboard">
                        {{ copy_label }}
                    </button>
                    <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            @click="embedCodePanelVisible=false">
                        {{ translate('close') }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="shareableLinkPanelVisible" class="absolute w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
            <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 16rem;">
                <span class="text-base text-theme-main font-bold mb-4">{{  translate('share-link-title') }}</span>
                <span class="text-sm text-theme-discrete font-bold mb-10">{{ translate('share-link-description') }}</span>
                <div class="text-sm text-theme-discrete mb-12">
                    <code>{{ shareableLinkCode }}</code>
                </div>
                <div class="flex flex-row items-center justify-center">
                    <button class="flex flex-row items-center justify-center text-base text-theme-control-label rounded-lg px-4 w-32 h-10"
                            :class="{'bg-theme-controls2 hover:bg-theme-controls1': !shareableLinkWasCopied && !shareableLinkHadError, 'bg-green-500 hover:bg-green-500': shareableLinkWasCopied, 'bg-red-500 hover:bg-red-500': shareableLinkHadError}"
                            @click.stop="copyLinkToClipboard">
                        {{ copy_label }}
                    </button>
                    <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            @click.stop="shareableLinkPanelVisible=false">
                        {{ translate('close') }}
                    </button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {
            return {

                duration: '...',
                plays: '',
                likes: '',
                dislikes: '',
                comments: '---',

                publish_date: '...',

                isLikeable: true,
                isDislikeable: true,

                embedCodePanelVisible: false,
                shareableLinkPanelVisible: false,

                copy_label: this.translate('copy'),
                shareableLinkWasCopied: false,
                shareableLinkHadError: false,

                embedCodeWasCopied: false,
                embedCodeHadError: false,

                currentUser: Laravel.user,

                // autoplayIsEnabled: this.$root.shared.autoplayIsEnabled

            }
        },

        computed: {

            /*autoplayIsEnabled: {
                get: function() {
                    return this.$root.shared.autoplayIsEnabled
                },
                set: function(newValue) {
                    Event.fire('toggleAutoplay');
                }
            },*/

            userAuthenticated() {
                return window.Laravel.user
            },

            userRole() {
                return window.Laravel.userRole
            },

            commentsUrl() {

                return this.baseurl + '/' + this.$root.shared.playerPayload.id;

            },

            downloadable() {

                return this.$root.shared.playerPayload.restrictions === 'Abierto' || this.$root.shared.playerPayload.restrictions === 'Open';

            },

            commentsTheme() {

                return this.$root.shared.theme === 'theme-light' ? 'light' : 'dark';

            },

            embedCode() {

                    let legacy = this.$root.shared.isLegacyContent ? '1' : '0';

                let tmp = '<div>\n' +
                    '  <div style="position:relative;overflow:hidden; padding-bottom:58%;height:100%;">\n' +
                    '    <iframe src="https://' +
                    window.location.hostname + '/embed/' + legacy + '/' + this.$root.shared.playerPayload.id +
                    '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen style="position:absolute;width:100%;height:100%;top:0;left:0;">\n' +
                    '    </iframe>\n' +
                    '  </div>\n' +
                    '</div>'

                return tmp;
            },

            shareableLinkCode() {

                return 'https://' + window.location.hostname + '/' + this.currentlocale + '/content/' + this.$root.shared.playerPayload.id;

            },

        },

        props: [
            'currentlocale',
            'baseurl',
            'default_thumbnail'
        ],

        methods: {

            toggleAutoplay() {
                Event.fire('toggleAutoplay');
            },

            editContent() {
                window.location='/' + this.currentlocale + '/admin/content/edit/' + this.$root.shared.playerPayload.id;
            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            gotoCategory(cat) {
                window.location= '/' + this.currentlocale + '/category/' + cat;
            },

            gotoTag(tagName) {
                window.location= '/' + this.currentlocale + '/element/tagname/' + tagName;
            },

            gotoSubCategory(subcat) {
                window.location = '/' + this.currentlocale + '/element/subcategory/' + subcat;
            },

            gotoCorrespondent() {
                window.location = '/' + this.currentlocale + '/element/correspondent/' + this.$root.shared.playerPayload.correspondent_id;
            },


            gotoPoi(personName) {
                window.location = '/' + this.currentlocale + '/element/poiname/' + personName;
            },

            gotoCountry(countryName) {
                window.location = '/' + this.currentlocale + '/element/countries/' + countryName;
            },


            getEmbedCode() {
                this.embedCodePanelVisible = true;
            },

            closePlayer() {
                /*console.log('Hiding the player...');*/

                // Before actually closing the player, let's restore the browser's address bar with the stored
                // previous URL, which should contain the state of it before the user opened the player view; just in case
                // this value for some weird reason has not been set, we will default to the site's root;
                // also, we are resetting the shared autoplayItemIndex to zero, to reset the autoplay flow.
                // We can also free up the "coming up content collection" since it is not needed right now,
                // same with the currently playing content id, which we will reset to nothing.
                window.history.pushState('Current Content', 'Back', this.$root.shared.previousPageURL ? this.$root.shared.previousPageURL : '/' + this.currentlocale)
                Event.fire('hidePlayer');
                this.$root.shared.autoplayItemIndex = 0
                this.$root.shared.comingUpContentCollection = ''
                this.$root.shared.currentlyPlayingContentId = ''
            },

            updateLikes() {

                if(Laravel.user) {

                    axios.get('/' + this.currentlocale + '/content/stats/add-like/' + this.$root.shared.playerPayload.id)
                        .then(response => {

                            this.$root.shared.contentLikes = JSON.stringify(response.data);
                            this.isLikeable = false;
                            this.isDislikeable = false;

                            this.flashMessage.success({
                                title: '',
                                message: 'Este Contenido se ha agregado a su Lista "Me Gusta"',
                                blockClass: 'p-6',
                                x: 25,
                                y: 250,
                                time: 3000
                            });
                        })
                        .catch(error => {
                            // alert('ERROR: ' + error);
                        });

                } else {

                    this.flashMessage.info({
                        title: '',
                        message: 'Para poder hacer "Me Gusta" o "No me Gusta" en el contenido, debe tener su sesión iniciada.',
                        blockClass: 'p-6',
                        x: 25,
                        y: 250,
                        time: 4000
                    });

                }
            },

            updateDislikes() {

                if(Laravel.user) {

                    axios.get('/' + this.currentlocale + '/content/stats/add-dislike/' + this.$root.shared.playerPayload.id)
                        .then(response => {

                            this.$root.shared.contentDislikes = JSON.stringify(response.data);
                            this.isDislikeable = false;
                            this.isLikeable = false;

                            this.flashMessage.success({
                                title: '',
                                message: 'Este Contenido ha sido marcado como "No me Gusta"',
                                blockClass: 'p-6',
                                x: 25,
                                y: 250,
                                time: 3000
                            });
                        })
                        .catch(error => {
                            // alert('ERROR: ' + error);
                        });

                } else {
                    this.flashMessage.info({
                        title: '',
                        message: 'Para poder hacer "Me Gusta" o "No me Gusta" en el contenido, debe tener su sesión iniciada.',
                        blockClass: 'p-6',
                        x: 25,
                        y: 250,
                        time: 4000
                    });
                }
            },

            downloadContent() {
                if(this.$root.shared.playerPayload.legacy) {
                    window.location=process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.filename;
                } else {
                    window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.filename + '/' + this.$root.shared.playerPayload.filename + '.mp4';
                }
                /*window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.filename + '/' + this.$root.shared.playerPayload.filename + '.mp4';*/
            },

            getShareableLink() {
                this.shareableLinkPanelVisible=true;
            },

            setCopyLabelOk() {
                this.copy_label = this.translate('copied');
            },

            setCopyLabelError() {
                this.copy_label = 'Error!';
            },

            copyLinkToClipboard() {

                this.$copyText(this.shareableLinkCode).then((e) => {
                    this.setCopyLabelOk();
                    this.shareableLinkWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.shareableLinkHadError=true;
                    console.log(e)
                })
            },

            copyEmbedCodeToClipboard() {
                this.$copyText(this.embedCode).then((e) => {
                    this.setCopyLabelOk();
                    this.embedCodeWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.embedCodeHadError=true;
                    console.log(e)
                })
            }

        },

        mounted() {
            gtag('event', 'page_view', {
                page_title: this.$root.shared.playerPayload.title,
                page_location: this.shareableLinkCode,
                send_to: 'UA-165737901-3'
            })

            // this.autoplayIsEnable = this.$root.shared.autoplayIsEnable
        }

    }

</script>

<style scoped>

    .icon-circled {
        background-color: var(--txt-copy-5);
    }

    .icon-circled:hover {
        background-color: var(--txt-copy-6);
        fill: var(--txt-main);
    }

    .inline-svg-icon {
        fill: var(--txt-discrete);
    }

    .inline-svg-icon:hover {
        fill: var(--txt-main);
    }

    /* CHECKBOX TOGGLE SWITCH */
    /* @apply rules for documentation, these do not work as inline style */
    .toggle-checkbox:checked {
        @apply: right-0 border-green-400;
        right: 0;
        border-color: #68D391;
    }
    .toggle-checkbox:checked + .toggle-label {
        @apply: bg-green-400;
        background-color: #68D391;
    }

</style>
